
import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as TodoWebsocket from './todo.websocket';

export function* createTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.createTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* editTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.editTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* deleteTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.deleteTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* completeTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.completeTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* completeHandover(action: any): SagaIterator {
  try {
    TodoWebsocket.completeHandover(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* hideTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.hideTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


export function* seenTodo(action: any): SagaIterator {
  try {
    TodoWebsocket.seenTodo(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


// WEBPACK FOOTER //
// ./src/services/todos/todo.saga.ts